import Model, { type HasMany, hasMany } from '@ember-data/model';
import { Type } from '@warp-drive/core-types/symbols';
import { RI_BREAKDOWNS } from 'frontend-utils/utils/constants/constant-values';
import type { RevenueInsightSegmentationValue } from 'lumen/models';

// Currently we use snake_case for the attributes to match the values of segmentationId from the API
// This will be changed to camelCase in https://otainsight.atlassian.net/browse/REV-530
export default class ReviApiResponse extends Model {
  [Type] = 'revi-api-response' as const;

  @hasMany('revenue-insight/segmentation-value', {
    async: false,
    inverse: null,
  })
  declare all: HasMany<RevenueInsightSegmentationValue>;

  @hasMany('revenue-insight/segmentation-value', {
    async: false,
    inverse: null,
  })
  declare booking_lead_time: HasMany<RevenueInsightSegmentationValue>;

  @hasMany('revenue-insight/segmentation-value', {
    async: false,
    inverse: null,
  })
  declare cancellation_lead_time: HasMany<RevenueInsightSegmentationValue>;

  @hasMany('revenue-insight/segmentation-value', {
    async: false,
    inverse: null,
  })
  declare company: HasMany<RevenueInsightSegmentationValue>;

  @hasMany('revenue-insight/segmentation-value', {
    async: false,
    inverse: null,
  })
  declare guest_country: HasMany<RevenueInsightSegmentationValue>;

  @hasMany('revenue-insight/segmentation-value', {
    async: false,
    inverse: null,
  })
  declare impact_date: HasMany<RevenueInsightSegmentationValue>;

  @hasMany('revenue-insight/segmentation-value', {
    async: false,
    inverse: null,
  })
  declare los: HasMany<RevenueInsightSegmentationValue>;

  @hasMany('revenue-insight/segmentation-value', {
    async: false,
    inverse: null,
  })
  declare origin: HasMany<RevenueInsightSegmentationValue>;

  @hasMany('revenue-insight/segmentation-value', {
    async: false,
    inverse: null,
  })
  declare pace: HasMany<RevenueInsightSegmentationValue>;

  @hasMany('revenue-insight/segmentation-value', {
    async: false,
    inverse: null,
  })
  declare pickup: HasMany<RevenueInsightSegmentationValue>;

  @hasMany('revenue-insight/segmentation-value', {
    async: false,
    inverse: null,
  })
  declare rate_code: HasMany<RevenueInsightSegmentationValue>;

  @hasMany('revenue-insight/segmentation-value', {
    async: false,
    inverse: null,
  })
  declare room_type: HasMany<RevenueInsightSegmentationValue>;

  @hasMany('revenue-insight/segmentation-value', {
    async: false,
    inverse: null,
  })
  declare segment: HasMany<RevenueInsightSegmentationValue>;

  @hasMany('revenue-insight/segmentation-value', {
    async: false,
    inverse: null,
  })
  declare source: HasMany<RevenueInsightSegmentationValue>;

  @hasMany('revenue-insight/segmentation-value', {
    async: false,
    inverse: null,
  })
  declare source_profile: HasMany<RevenueInsightSegmentationValue>;

  @hasMany('revenue-insight/segmentation-value', {
    async: false,
    inverse: null,
  })
  declare subscription_id: HasMany<RevenueInsightSegmentationValue>;

  @hasMany('revenue-insight/segmentation-value', {
    async: false,
    inverse: null,
  })
  declare travel_agent: HasMany<RevenueInsightSegmentationValue>;

  @hasMany('revenue-insight/segmentation-value', {
    async: false,
    inverse: null,
  })
  declare weekday: HasMany<RevenueInsightSegmentationValue>;

  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  get keys() {
    return Object.values(RI_BREAKDOWNS).filter(
      (key) => this[key] !== undefined,
    );
  }
}

export type ReviApiResponseLike = {
  -readonly [K in keyof Omit<
    ReviApiResponse,
    keyof Model
  >]: ReviApiResponse[K] extends HasMany<RevenueInsightSegmentationValue>
    ? RevenueInsightSegmentationValue[]
    : ReviApiResponse[K];
};
